import { TRootState }    from 'Redux/Reducers';
import { arrayContains } from 'Utils';
import Actions           from 'Redux/Actions';

export const isSettingsLoading = (state: TRootState): boolean =>
  arrayContains(state.settings.openRequests, [
    Actions.updateSettingsRequest.type,
  ]);
